import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ScheduledStatus: LoadableType<{
	contentId: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-banner-itemsscheduled-statusScheduledStatus" */ '../src/banner-items/scheduled-status/ScheduledStatus.tsx'
			)
		).ScheduledStatus,
});
